import React, {Component} from 'react';
import '../../../../styles/Home.css'
import AdminService from "../../../../admin/adminComponents/AdminService";
import Panel from "../../Panel";
import {Button} from "react-bootstrap";
import BiletyMiesieczneService from "../mojeBiletyComponents/BiletyMiesieczneService";
import {NotificationManager} from "react-notifications";

export default class Event extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: []
        }
    }

    componentDidMount() {
        AdminService.getStronaById(this.props.match.params.index)
            .then(function (response) {
                let res = response.data;
                this.setState({data: res, loading: false})
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }


    zapiszSie(){
        BiletyMiesieczneService.zapiszEvent(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, this.state.data.id).then((response)=>{
            NotificationManager.success('Zapisano pomyślnie', 'Informacja', 5000);
        })
    }

    render() {
        return <Panel>
            <div>

                {this.state.loading ? <div>
                    <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                        className="fa fa-spinner fa-pulse fa-2x fa-fw"
                        style={{
                            color: '#58b13d'
                        }}> </i></div>
                </div> : <div>
                    <div>
                        <h4 style={{textAlign: 'center', marginBottom: 20}}><b>{this.state.data.tytul}</b></h4>
                        <br/>
                        {this.state.data.pliki.length > 0 ? <center><img
                            src={'data:' + this.state.data.pliki[0].typ + ';base64, ' + this.state.data.pliki[0].dane}
                            style={{maxWidth: '75%', maxHeight: 225}}/>
                        </center> : null}
                        <hr/>
                        <div className="row">
                            <div className="col-lg-6">
                                <small><b>{this.state.data.dataWpisu}</b>
                                </small>
                            </div>
                            <div className="col-lg-6 text-right">
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12" style={{marginTop: 10}}
                                 dangerouslySetInnerHTML={{__html: this.state.data.tresc}}/>
                        </div>
                        <div className={"row"}>
                            <div className={"col-lg-12"}>
                                <Button bsStyle='success'
                                        onClick={() => this.zapiszSie()}>Zapisz się</Button>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/eventyComponents/Event.js